import { joiResolver } from '@hookform/resolvers/joi';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import {
  useCreateSendEmailRemainder,
  useCreateSendSelfClipEmailRemainder,
  useGetInstitutions,
} from 'api/institutions/institutions';
import { EventState, InstitutionsResponse } from 'api/institutions/institutions.types';
import { AppRoute } from 'routing/AppRoute.enum';

import { Clips } from './Clips';
import { ClipsInputs } from './Clips.types';
import { defaultValues, schema } from './Clips.utils';
// import { BaseSyntheticEvent } from 'react';

export const ClipsContainer = () => {
  const navigate = useNavigate();

  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ClipsInputs>({
    reValidateMode: 'onChange',
    resolver: joiResolver(schema),
    mode: 'onChange',
    defaultValues: defaultValues,
  });
  const { email } = watch();

  const { mutate: saveInstituitionDetails } = useCreateSendEmailRemainder({});

  const { mutate: SelfClipEmail } = useCreateSendSelfClipEmailRemainder({});

  const sendEmail = async (id: string, email?: string) => {
    await saveInstituitionDetails({
      body: {
        participantId: id,
        email: email,
      },
    });
  };

  const sendSelfClipEmail = async (id: string) => {
    await SelfClipEmail({
      body: {
        participantId: id,
      },
    });
  };

  const { mutate, isLoading } = useGetInstitutions({
    onSuccess: (data: InstitutionsResponse) => {
      if (!data?.length) {
        // No email
        navigate(AppRoute.checkEmail);
      } else if (data?.length > 1) {
        // multiple
        navigate(AppRoute.multiEventSuccess, { state: { data: data, email: email } });
      } else if (
        data[0]?.eventData?.isSelfClipping &&
        data[0]?.eventData?.isEventVideoInclude &&
        !data[0]?.isClipVideoUrlInclude &&
        !data[0]?.eventData.isGifGenerationCompleted
      ) {
        // Show self clipping url for open site for processed event - send the email
        navigate(AppRoute.selfClipGifInProgress, { state: { email: email } });
      } else if (
        data[0].eventData.isSelfClipping &&
        !data[0].clipSearchEnable &&
        !data[0].isClipVideoUrlInclude &&
        data[0].eventData.isGifGenerationCompleted
      ) {
        navigate(AppRoute.selfClippingCloseSystem, { state: { email: email } });
        sendSelfClipEmail(data[0].id);
      } else if (
        data[0]?.eventData.isSelfClipping &&
        data[0]?.clipSearchEnable &&
        !data[0]?.isClipVideoUrlInclude &&
        data[0]?.eventData.isGifGenerationCompleted
      ) {
        // Show self clipping url for open site - open the self clipping url - with content page
        navigate(AppRoute.selfClipping, { state: { participantId: data[0]?.id } });
      } else if (
        data[0]?.eventData.isSelfClipping &&
        !data[0]?.eventData.isEventVideoInclude &&
        !data[0]?.isClipVideoUrlInclude &&
        !data[0]?.eventData.isGifGenerationCompleted
      ) {
        // Show self clipping url for open site - open the self clipping url - with content page
        navigate(AppRoute.noClipUserExist);
      } else if (data[0].eventData.eventIsArchived) {
        navigate(AppRoute.clipDeleted);
      } else if (data[0]?.eventData.state === EventState.ClippingInProgress) {
        navigate(AppRoute.clipInProgress, { state: { data: data[0], email: email } });
      } else if (data[0]?.eventData.state === EventState.WaitingForAssets) {
        navigate(AppRoute.clipWaitingAssets, { state: { data: data[0], email: email } });
      } else if (data[0]?.eventData.state === EventState.ReviewNeeded) {
        navigate(AppRoute.noClipUserExist);
      } else if (data[0]?.eventData.state === EventState.ReadyToClip) {
        navigate(AppRoute.noClipUserExist);
      } else if (!data[0]?.clipSiteUrl && data[0]?.clipSearchEnable && !data[0].eventData.eventIsArchived) {
        navigate(AppRoute.noClipUserExist);
      } else if (data[0]?.clipSearchEnable && !data[0].eventData.eventIsArchived) {
        navigate(AppRoute.singleEventSuccess, { state: data });
      } else if (!data[0]?.clipSearchEnable && data[0].isClipSiteUrlInclude) {
        navigate(AppRoute.clipCloseSuccess, { state: { data: data, email: email } });
        sendEmail(data[0].id);
      }

      if (data?.length > 1) {
        navigate(AppRoute.multiEventSuccess, { state: { data: data, email: email } });
      } else if (
        data[0].eventData.isSelfClipping &&
        data[0].clipSearchEnable &&
        !data[0].isClipSiteUrlInclude &&
        data[0].eventData.isGifGenerationCompleted
      ) {
        navigate(AppRoute.selfClipping, { state: { participantId: data[0]?.id } });
      } else if (
        data[0].eventData.isSelfClipping &&
        !data[0].clipSearchEnable &&
        !data[0].isClipSiteUrlInclude &&
        data[0].eventData.isGifGenerationCompleted
      ) {
        navigate(AppRoute.selfClippingCloseSystem, { state: { email: email } });
        sendSelfClipEmail(data[0].id);
      } else if (
        data[0].eventData.isSelfClipping &&
        // data[0].clipSearchEnable &&
        !data[0].isClipSiteUrlInclude &&
        !data[0].eventData.isGifGenerationCompleted
      ) {
        navigate(AppRoute.selfClipNoCeremonyVideo);
      }
    },
  });

  const handleOnSubmit = async () => {
    await mutate({ params: { email } });
  };

  return (
    <Clips
      register={register}
      errors={errors}
      email={email}
      isLoading={isLoading}
      onSubmit={handleSubmit(handleOnSubmit)}
    />
  );
};
